/*
 * サブシステム名：マスタ管理
 * 機能名：燃費管理
 */

import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
// import validators from '@/rahmen/validators'

import d2fmt from '@/ddv2.library/utils/formatter'
// import modals from '@/ddv2.library/modals'
// import spsvalidator from '@/ddv2.library/validator4sps'

// import header from '@/ddv2.library/header'
import DdCustomButton from '@/components/DdCustomButton'
import DdDropDown from '@/components/DdDropDown'
import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdMonthBox from '@/components/DdMonthBox'
import DdMonthBoxInside from '@/components/DdMonthBoxInside'
import DdSpreadSheet from '@/components/DdSpreadSheetCe'
import DdSubHeader from '@/components/DdSubHeader'
import DdSwitch from '@/components/DdSwitch'
import DdTransparentButton from '@/components/DdTransparentButton'
import VTour from '@/components/DdCoachMark.vue'
import CoachMark from './CoachMark/D2MSTT0480.js'

export default {
  name: 'MstNenpiListEdit',
  mixins: [flowMixin],
  components: {
    VTour,
    DdCustomButton,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdMonthBox,
    DdMonthBoxInside,
    DdSpreadSheet,
    DdSubHeader,
    DdSwitch,
    DdTransparentButton
  },
  data: () => ({
    conditions: {
      mstNenpiCategoryId: null,
      targetYm: null
    },
    isConditionHide: false,
    isEditCategory: false,
    isSearched: false,

    switchYm: null,
    searchText: null,
    selected: [],
    categoryRows: [],
    categorySelected: [],

    // 検索結果保持
    searchResultRow: [],

    // 表示用
    rows: [],

    // ヘッダー
    categoryHeaders: [],
    headers: [],

    // 保存用
    targetNenpiCategory: [],
    targetNenpi: [],

    // 操作ガイド用
    startCoachMark: false,
    steps: CoachMark.STEPS,

    modeKengen: 0,

    // スプレッドシートオプション
    option: {
      // // テーブル最大高さ
      // tableHeight: '70vh',
      // テーブル最大横幅
      tableWidth: 'inherit',
      // 列追加
      allowInsertColumn: false,
      // 行追加※改行キーのみ
      allowManualInsertRow: false,
      // 列削除
      allowDeleteColumn: false,
      // 行削除
      allowDeleteRow: false,
      // 列ドラッグ
      columnDrag: false,
      // 行ドラッグ
      rowDrag: false,
      // ソート
      columnSorting: false,
      // スクロール有効化
      tableOverflow: true,
      // コンテキストメニュー
      contextmenu: false,
      // セル内HTML無効※ヘッダー改行のため有効
      stripHTML: false,
      // 計算式のサポート
      parseFormulas: false,
      // セル選択時の右下の■ドラッグでのコピー
      selectionCopy: false,
      // CSV出力
      allowExport: false,
      // フィルターオプション
      search: true,
      // ページネーションオプション
      pagination: 25,
      paginationOptions: [10, 25, 50, 100],
      // デフォルト文言変更
      text: {
        show: '1ページ当たりの行数:',
        entries: '',
        showingPage: '全部で {1} ページあります',
        search: 'さらにフリーワードで絞り込む',
        noRecordsFound: '対象データがありません'
      }
    },
    // 画面側からのエラーリスト
    outsideErrorList: []
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      currentKaishaCode: 'users/currentKaishaCode',
      nenpiCategoryList: 'DDMasters/mstNenpiCategory',
      kubunList: 'DDMasters/msysKubun'
    }),
    filteredNenpiCategoryList () {
      var defArray = [{ value: null, text: '未選択' }]
      const resultArray = this.categoryRows.filter((elem) => {
        return elem.hyojiFlg === true
      }).map(elem => {
        return {
          value: elem.id,
          text: `${elem.nenpiCategoryCd} : ${elem.nenpiCategoryNm}`
        }
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder > elem2.hyojiOrder) { return 1 }
        if (elem1.hyojiOrder === elem2.hyojiOrder) { return 0 }
        return -1
      })
      return defArray.concat(resultArray)
    },

    /**
     *
     * @returns 燃費カテゴリ
     */
    computedColXNumList () {
      var result = {}
      this.categoryHeaders.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    isCategoryMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const saveTargetRow = this.categoryRows.filter(function (elem) {
        return elem.editFlg === true && elem.memo !== 'Ｅ'
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    },

    /**
     * 燃料
     * @returns
     */
    computedColNumList () {
      var result = {}
      this.headers.forEach((elem, index) => {
        result[elem.name] = index
      })
      return result
    },
    isMultiSaveButtonDisabled () {
      if (this.modeKengen !== 2) {
        return false
      }
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true
      })
      if (saveTargetRow.length < 1) {
        return true
      }
      return false
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['mstnenpicategory', 'msyskubun'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            self.setCategoryHeader()
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              mstNenpiCategoryId: null
            }
            self.categoryRows = self.nenpiCategoryList.map((elem, index) => {
              const m = self.kubunList.find((item) => item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'KBN061' && item.code === elem.nenpiCategoryKbn)
              if (![undefined, null].includes(m)) {
                elem.rowNo = index + 1
                elem.editFlg = false
                elem.memo = ''
                elem.nenpiCategoryKbnNm = m.codeNm
              }
              return elem
            })
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onClearButtonClick: function () {
      this.isSearched = false
      this.clear()
    },
    clear: function () {
      this.conditions = {
        mstNenpiCategoryId: null,
        targetYm: null
      }
      this.rows = []
    },
    onSearchButtonClick: function () {
      this.isSearched = true
      this.switchYm = this.conditions.targetYm
      this.$nextTick(function () {
        this.searchAction(false)
      })
    },
    searchAction: function (noMessage) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwcMstNenpi/search', self.conditions)
              .then((data) => {
                self.setHeader()
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          const resultData = data.payload
          // 表示領域初期化
          self.rows = []
          // 検索結果保持用にセット
          resultData.map((elem, index) => {
            // スプレッドシート用にここで編集
            elem.rowNo = index + 1
            elem.editFlg = false
            elem.memo = ''
            elem.tekiyoStartYmd = filter.dateFormatter(elem.tekiyoStartYmd)
            elem.tekiyoEndYmd = filter.dateFormatter(elem.tekiyoEndYmd)
            elem.tekiyoStartYm = elem.tekiyoStartYmd.substr(0, 7)
            elem.tekiyoEndYm = elem.tekiyoEndYmd.substr(0, 7)
            elem.nenpi = filter.numericFormatter(elem.nenpi)
            elem.hyojiOrder = filter.numericFormatter(elem.hyojiOrder)
            return elem
          })
          self.searchResultRow = resultData

          // 画面表示用フィルタ
          const dispData = self.searchResultRow.filter(function (elem) {
            return [undefined, null, ''].includes(self.switchYm) || (![undefined, null, ''].includes(self.switchYm) && (elem.tekiyoStartYm <= self.switchYm && elem.tekiyoEndYm >= self.switchYm))
          })
          self.rows = Object.assign([], dispData)
        },
        isNoMessageModeMethod: function () {
          return noMessage
        },
        getSavedInputMethod: function () {
          return {}
        },
        failureValidateMethod: function () {
          self.torikomiConditonsRequired = true
          self.tableRowRequired = true
        }
      }
      this.search(opt)
    },
    // 検索前チェック
    searchValidate: function () {
      return true
    },
    //
    onChangeTargetYm: function () {
      const self = this
      // 画面表示用フィルタ
      const dispData = this.searchResultRow.filter(function (elem) {
        return [undefined, null, ''].includes(self.switchYm) || (![undefined, null, ''].includes(self.switchYm) && (elem.tekiyoStartYm <= self.switchYm && elem.tekiyoEndYm >= self.switchYm))
      })
      this.rows = Object.assign([], dispData)
    },

    /**
     * 燃費カテゴリ編集
     */
    setCategoryHeader () {
      const self = this
      return new Promise(resolve => {
        // ヘッダー定義
        self.categoryHeaders = [
          { title: '', name: 'id', type: 'hidden' },
          { title: '', name: 'rowNo', type: 'hidden' },
          { title: '', name: 'editFlg', type: 'hidden' },
          { title: '変更', name: 'memo', type: 'text', customInput: null, readOnly: true, width: '35px' },
          { title: 'カテゴリコード', name: 'nenpiCategoryCd', type: null, customInput: 'text', customInputLength: 6, customInputType: 'Free', readOnly: false, width: '120px' },
          { title: 'カテゴリ名称', name: 'nenpiCategoryNm', type: null, customInput: 'text', customInputLength: 20, customInputType: 'Free', readOnly: false, width: '200px' },
          { title: 'カテゴリ区分', name: 'nenpiCategoryKbnNm', type: 'text', customInput: null, readOnly: true, width: '120px' },
          { title: '表示順', name: 'hyojiOrder', type: null, customInput: 'numeric', customInputIntDigit: 6, customInputDecimalDigit: 0, readOnly: true, width: '100px' },
          { title: '表示有無', name: 'hyojiFlg', type: 'checkbox', customInput: null, width: '60px' }
        ]

        resolve()
      })
    },
    onAddNenpiCategory: function () {
      this.isEditCategory = true

      const self = this
      this.categoryRows = this.nenpiCategoryList.map((elem, index) => {
        const m = this.kubunList.find((item) => item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'KBN061' && item.code === elem.nenpiCategoryKbn)
        elem.rowNo = index + 1
        elem.nenpiCategoryKbnNm = m.codeNm
        return elem
      })
    },
    onCloseNenpiCategory: function () {
      this.isEditCategory = false
      // indexeddb更新
    },
    rowAppendCategory: function (num) {
      const self = this
      const m = this.kubunList.find((item) => item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'KBN061' && item.code === '02')
      const hyojiOrder = 1 + Math.max.apply(null, this.categoryRows.filter((elem) => {
        return elem.hyojiOrder < 9999
      }).map(function (o) {
        return [undefined, null, ''].includes(o.hyojiOrder) ? 0 : o.hyojiOrder
      }))

      for (let i = 0; i < num; i++) {
        const newrow = {
          id: 0,
          editFlg: false,
          memo: '',
          nenpiCategoryCd: '',
          nenpiCategoryNm: '',
          nenpiCategoryKbn: '02',
          nenpiCategoryKbnNm: m.codeNm,
          hyojiOrder: hyojiOrder,
          hyojiFlg: true,
          rowNo: this.categoryRows.length + 1
        }
        this.categoryRows.push(newrow)
      }
      // 画面への再描写 ※強制発火用にspliceを実行
      this.categoryRows.splice()
    },
    onCategorySaveButtonClick: function () {
      const self = this
      // 変更フラグONかつ発生年月日≠Nullのもののみ対象
      const saveTargetRow = this.categoryRows.filter(function (elem) {
        return elem.editFlg === true && !['', null, undefined].includes(elem.nenpiCategoryCd) && !['', null, undefined].includes(elem.nenpiCategoryNm) && !['', null, undefined].includes(elem.hyojiOrder)
      })
      if (saveTargetRow.length < 1) { return }

      saveTargetRow.map((elem) => {
        elem.id = [undefined, null, ''].includes(elem.id) ? -1 : elem.id
        // 数値変換
        elem.hyojiOrder = d2fmt.removeComma(elem.hyojiOrder)
        return elem
      })

      this.targetNenpiCategory = saveTargetRow
      this.$nextTick(function () {
        self.saveNepiCategoryAction()
      })
    },
    saveNepiCategoryAction: function () {
      this.Effects.loadStart()
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/MstNenpiCategory/RegisterMulti', self.targetNenpiCategory)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            if (data.isValid) {
              self.categoryRows = data.payload.item1.map(elem => {
                const m = self.kubunList.find((item) => item.kaishaCd === self.currentKaishaCode && item.kbnShuruiCd === 'KBN061' && item.code === elem.nenpiCategoryKbn)
                return {
                  ...elem,
                  nenpiCategoryKbnNm: m.codeNm
                }
              }).sort((elem1, elem2) => {
                if (elem1.hyojiOrder > elem2.hyojiOrder) { return 1 }
                if (elem1.hyojiOrder === elem2.hyojiOrder) { return 0 }
                return -1
              })
            }
            // 画面への再描写 ※強制発火用にspliceを実行
            self.categoryRows.splice()
            this.$store.dispatch('DDMasters/loadMasters', { list: ['mstnenpicategory'], version: 1 }).then(() => {
              self.setCategoryHeader()
              self.Effects.loadComplete()
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    },
    // 登録前チェック
    registerValidate: function () {
      return true
    },

    /**
     * 燃費編集
     */
    setHeader () {
      const self = this
      return new Promise(resolve => {
        var wkNenpiCategoryList = ['未選択']
        const mNenpiCategoryList = self.categoryRows.filter((t) => {
          return t.hyojiFlg === true
        })
        const tNenpiCategoryList = mNenpiCategoryList.map(elem => {
          return elem.nenpiCategoryNm
        })
        wkNenpiCategoryList = wkNenpiCategoryList.concat(tNenpiCategoryList)
        // ヘッダー定義
        self.headers = [
          { title: '', name: 'id', type: 'hidden' },
          { title: '', name: 'rowNo', type: 'hidden' },
          { title: '区分', name: 'memo', type: 'text', customInput: null, readOnly: true, width: '40px' },
          { title: '変更', name: 'editFlg', type: 'checkbox', customInput: null, width: '35px' },
          { title: '', name: 'errFlg', type: 'hidden' },
          { title: '削除', name: 'delFlg', type: 'checkbox', customInput: null, width: '35px' },
          { title: 'カテゴリ', name: 'nenpiCategoryNm', type: 'dropdown', customInput: null, source: wkNenpiCategoryList, required: true, width: '200px', autocomplete: true },
          { title: '適用開始日', name: 'tekiyoStartYmd', type: null, customInput: 'date', validateType: 'Date', required: true, readOnly: false, width: '140px' },
          { title: '適用終了日', name: 'tekiyoEndYmd', type: null, customInput: 'date', validateType: 'Date', required: true, readOnly: false, width: '140px' },
          { title: '燃費', name: 'nenpi', type: null, customInput: 'numeric', customInputIntDigit: 4, customInputDecimalDigit: 1, validateType: 'Numerical', required: true, readOnly: false, width: '120px' },
          { title: '表示順', name: 'hyojiOrder', type: null, customInput: 'numeric', customInputIntDigit: 6, customInputDecimalDigit: 0, validateType: 'Numerical', required: true, readOnly: false, width: '100px' }
        ]

        resolve()
      })
    },
    rowAppend: function (num) {
      for (let i = 0; i < num; i++) {
        const max = Math.max.apply(null, this.rows.filter((elem) => {
          return elem.hyojiOrder < 9999
        }).map(function (o) {
          return [undefined, null, ''].includes(o.hyojiOrder) ? 0 : o.hyojiOrder
        }))
        const hyojiOrder = 1 + (max !== -Infinity ? max : 0)
        const newrow = {
          id: 0,
          editFlg: false,
          memo: '',
          mstNenpiCategoryId: null,
          nenpiCategoryNm: '',
          tekiyoStartYmd: null,
          tekiyoEndYmd: null,
          nenpi: null,
          hyojiOrder: hyojiOrder,
          rowNo: this.rows.length + 1
        }
        this.rows.push(newrow)
      }
      // 画面への再描写 ※強制発火用にspliceを実行
      this.rows.splice()
    },
    onNewRowButtonClick: function (e) {
      this.rowAppend(1)
    },
    onMultiSaveButtonClick: function () {
      const self = this
      // 変更フラグONかつ発生年月日≠Nullのもののみ対象
      const saveTargetRow = this.rows.filter(function (elem) {
        return elem.editFlg === true && !['', null, undefined].includes(elem.nenpiCategoryNm) && !['', null, undefined].includes(elem.tekiyoStartYmd) && !['', null, undefined].includes(elem.tekiyoEndYmd) && !['', null, undefined].includes(elem.hyojiOrder)
      })
      if (saveTargetRow.length < 1) { return }

      saveTargetRow.map((elem) => {
        elem.id = [undefined, null, ''].includes(elem.id) ? -1 : elem.id
        // 数値変換
        elem.hyojiOrder = d2fmt.removeComma(elem.hyojiOrder)
        return elem
      })

      /**
       * リスト項目テキスト⇒ID/Code変換
       */
      // 燃費カテゴリID変換
      saveTargetRow.filter((elem) => {
        return ![null, ''].includes(elem.mstSharyoNm)
      }).map((elem) => {
        const m = self.categoryRows.filter(function (item) {
          return item.nenpiCategoryNm === elem.nenpiCategoryNm
        })
        if (m.length > 0) {
          elem.mstNenpiCategoryId = m[0].id
        }
        return elem
      })

      this.targetNenpi = saveTargetRow
      this.$nextTick(function () {
        self.saveNepiAction()
      })
    },
    saveNepiAction: function () {
      this.Effects.loadStart()
      const self = this
      const opt = {
        registerRequestPromise: function () {
          return self.HttpClient.post('/api/v1/MstNenpi/RegisterMulti', self.targetNenpi)
        },
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.Effects.loadComplete()

            this.$nextTick(function () {
              this.searchAction(true)
            })
            resolve()
          })
        },
        getIdMethod: () => {
          return 0
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        isNoMessageModeMethod: function () {
          return false
        },
        getSavedInputMethod: function () {
          return true
        }
      }
      this.register(opt)
    }
  }
}
